import angular from 'angular';

import managePreviewRedirects from '../../../account/managePreviewRedirects';
import { accessLevels, PREMIUM_FEATURE_NAMES } from '../../../constants';
import tagsBgPng from '../../../assets/images/premium-locked-screen/tag/header.png';
import tagsDetailsImage from '../../../assets/images/premium-locked-screen/tag/details.png';
import filterImage from '../../../assets/images/premium-locked-screen/tag/filter.png';

import previewUrl from './preview.html';
import manageTagComponent from './manageTagComponent';
import tagsComponent from './tagsComponent';

const tagsModule = angular.module('sling.dashboard.manage.tags', []);

tagsModule.config(($stateProvider) => {
  $stateProvider.state('dashboard.manage.tags', {
    abstract: true,
    url: '/tags',
    template: '<ui-view></ui-view>',
    resolve: {
      async tags(TagsService) {
        'ngInject';

        await TagsService.loadData();
      },
    },
  });

  $stateProvider.state('dashboard.manage.tags.list', {
    url: '/',
    template: "<manage-tags column-subset=\"['name', 'memberCount', 'options']\"></manage-tags>",
    data: {
      title: 'Tags',
    },
  });

  $stateProvider.state('dashboard.manage.tags.add', {
    url: '/add',
    controllerAs: 'ctrl',
    controller: function addTagController() {
      this.tag = {
        type: 'tag',
      };
    },
    template: '<manage-tag tag="ctrl.tag"></manage-tag>',
  });

  $stateProvider.state('dashboard.manage.tags.edit', {
    url: '/{groupId:[0-9]+}',
    reloadOnSearch: false,
    controller: function editPositionController(
      PersonaCollection,
      Restangular,
      $state,
      $stateParams,
      previousState
    ) {
      'ngInject';

      this.previousState = previousState;
      const tag = PersonaCollection.tags.find((g) => String(g.id) === $stateParams.groupId);

      if (!tag) {
        $state.go('dashboard.manage.tags.list');
      } else {
        this.tag = Restangular.copy(tag);
      }
    },
    template: `
          <manage-tag
            ng-if="ctrl.tag"
            tag="ctrl.tag"
            previous-state="ctrl.previousState">
            </manage-tag>`,
    controllerAs: 'ctrl',
    resolve: {
      previousState($transition$, $state) {
        const from = $transition$.from();
        return {
          name: from.name,
          params: { ...$state.params },
        };
      },
    },
  });

  $stateProvider.state('dashboard.manage.tags.preview', {
    url: '/preview',
    templateUrl: previewUrl,
    data: {
      title: 'Preview',
      access: accessLevels.manager,
    },
    controllerAs: 'ctrl',
    controller: function controller() {
      this.previewImageUrl = tagsBgPng;
      this.tagsDetailsImage = tagsDetailsImage;
      this.filterImage = filterImage;
      this.TAGS_FEATURE_NAME = PREMIUM_FEATURE_NAMES.tags;
    },
  });
});

tagsModule.run(($transitions, Authentication) => {
  $transitions.onStart(
    {
      to: 'dashboard.manage.tags.**',
    },
    (transition) =>
      managePreviewRedirects(
        Authentication,
        transition,
        'tags',
        'dashboard.manage.tags',
        'dashboard.manage.tags.list'
      )
  );
});

tagsModule.component('manageTags', tagsComponent);
tagsModule.component('manageTag', manageTagComponent);

export default tagsModule.name;
